<template>
  <div class="login__sign-in-links">
  <div class="login__sign-in-link">
    <GoogleLogin :callback="onGoogleSignInSuccess" prompt>
      <el-button type="primary" native-type="button" plain>
        <icon
          glyph="google-logo"
          :width="16"
          :height="16"
          class="login__sign-in-icon"
        />
        Continue with Google</el-button
      >
    </GoogleLogin>
  </div>

  <div class="login__sign-in-link">
    <el-button
      type="primary"
      native-type="button"
      plain
      :disabled="true"
      @click.prevent="loginWithFacebook"
    >
      <icon
        glyph="facebook-logo"
        :width="16"
        :height="16"
        class="login__sign-in-icon"
      />
      Continue with Facebook
    </el-button>
  </div>
</div>
</template>

<script>
import Icon from '@/components/common/Icon.vue';
import {
  AUTH_FACEBOOK,
  AUTH_GOOGLE,
  GET_USER_CONTACT_INFO,
} from '@/store/mutationTypes.js';
import { facebookScope, initFacebookSDK } from '@/helpers/facebook_oAuth.js';
import { disableButton } from '@/mixins/disableButton.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';

export default {
  name: 'ExternalLogin',
  components: {
    Icon,
  },
  mixins: [disableButton],
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      errors: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    isFormFilled() {
      const { loginForm } = this;
      return Object.values(loginForm).every((value) => !!value);
    },
    confirmationCode() {
      return this.$route.query.code || null;
    },
  },
  mounted() {
    initFacebookSDK();
  },

  methods: {
    showMessage,
    parseErrorsByFields,
    async onGoogleSignInSuccess(response) {
      try {
        this.disableButton('login');

        console.log('Google login response:', response);

        // Access token extraction based on Google API
        const { code } = response; // Modern libraries often use `credential` for tokens
        if (!code) {
          throw new Error('Google login response does not contain a credential');
        }

        // Send the access token and account details to the backend
        await this.$store.dispatch(AUTH_GOOGLE, {
          code: code,
          accountId: response.clientId || response.profileObj?.googleId, // Replace with correct field
        });

        this.enableButton('login');

        // Check for authentication errors
        const errors = this.$store.state.user.authErrors;
        if (errors) {
          this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
        } else {
          // Fetch additional user info if needed
          await this.$store.dispatch(GET_USER_CONTACT_INFO);
        }
      } catch (error) {
        console.error('Error during Google Sign-In:', error);
        this.onGoogleSignInError(error);
      } finally {
        this.enableButton('login');
      }
    },

    loginWithFacebook() {
      window.FB.login(async (response) => {
        this.disableButton('login');
        
        const { accessToken, userID } = { ...response.authResponse };

        await this.$store.dispatch(AUTH_FACEBOOK, {
          accessToken,
          accountId: userID,
        });
        this.enableButton('login');

        const errors = this.$store.state.user.authErrors;
        if (errors) {
          this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
        } else {
          this.$store.dispatch(GET_USER_CONTACT_INFO);
        }
      }, facebookScope);
    },
    onGoogleSignInError(error) {
      console.error('Google Sign-In failed:', error);
      this.showMessage({
        type: 'error',
        message: 'Google sign-in failed. Please try again.',
      });
    },
  },
};
</script>
